import React, { useEffect, useState } from 'react';
import ReusableModal from '../../ui/organisms/Modal/CustomModal'; // Import the reusable modal component
import {
  Box,
  Button,
  Divider,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextareaAutosize,
} from '@mui/material';
import CustomTypography from '../../ui/atoms/CustomTypography';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { getScriptSave } from '../../redux/reducer/coreScriptReducer';
import { formatValue } from '../../utils/helpers/formatValue';
import { styled } from '@mui/material/styles';
import useFollowupReasons from '../../utils/helpers/useFollowupReasons';
import { renderFormattedAnswers } from '../../utils/helpers/RenderFormatAnswers';

type SendFollowupProps = {
  isModalOpen: boolean;
  handleModalClose: () => void;
  keyToString: (key: string) => string;
  question_Title: string;
  title: string;
  question: any;
  handleSendFollowUp: (selectedReason: any, comments: string) => void;
  // comment: string;
  // handleCommentChange: (event: React.ChangeEvent<HTMLTextAreaElement>)=> void;
};

const Textarea = styled(TextareaAutosize)(
  () => `
    display: flex;
    height: 100px;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    background: #FFF;
  `
);

const SendFollowup = ({
  isModalOpen,
  handleModalClose,
  keyToString,
  question_Title,
  title,
  question,
  handleSendFollowUp,
}: SendFollowupProps) => {
  const [selectedReason, setSelectedReason] = useState<any | null>(null);
  const [comment, setComment] = useState('');
  const saveData = useSelector(getScriptSave);
  const contextId = useSelector(
    (state: RootState) => state.contextId.contextId
  );
  useEffect(() => {
    // Debounce variables
    let resizeTimeout: NodeJS.Timeout | null = null;
    const delay = 200; // The debounce delay time in ms (200ms in this case)

    // Create the ResizeObserver
    const resizeObserver = new ResizeObserver(() => {
      // Clear previous timeout to reset the debounce logic
      if (resizeTimeout) clearTimeout(resizeTimeout);

      // Set a new timeout to trigger resize action after the delay
      resizeTimeout = setTimeout(() => {
        // console.log('Resize event triggered!');
        return;
      }, delay);
    });

    // Observe the root element or any element you want to track
    const rootElement = document.getElementById('root');
    if (rootElement) {
      resizeObserver.observe(rootElement);
    }

    // Cleanup: disconnect the observer and clear the timeout when the component unmounts
    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, []); // The empty array ensures this useEffect runs only once when the component mounts

  const handleSelectReason = (event: SelectChangeEvent) => {
    const recievedValues = JSON.parse(event.target.value);
    setSelectedReason(recievedValues);
  };

  const reasonOptions = useFollowupReasons();

  const handleCommentChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    if (value?.length <= 3800) {
      setComment(value);
    }
  };

  const closeModal = () => {
    setSelectedReason(null);
    setComment('');
    handleModalClose();
  };
  return (
    <ReusableModal isOpen={isModalOpen} onClose={closeModal} width={600}>
      <Box
        sx={{
          display: 'flex',
          padding: '14px 32px 14px 32px',
          justifyontent: 'flex-end',
          aligntems: 'flex-start',
          gap: '27px',
          alignelf: 'stretch',
          background: '#F7F7F7',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            alignSelf: 'stretch',
            flex: '1',
          }}
        >
          <CustomTypography
            variant='h2'
            sx={{
              color: '#343330',
              // font-feature-settings: 'clig' off, 'liga' off;
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: 'normal',
              textTransform: 'capitalize',
            }}
          >
            Send Follow-Up
          </CustomTypography>
          <Button
            sx={{
              display: 'flex',
              padding: '5px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={handleModalClose}
          >
            <CloseIcon />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          padding: '14px 32px',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          gap: '15px',
          alignSelf: 'stretch',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            // gap: '100px',
            flex: '1',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '8px',
              // flex: '1',
            }}
          >
            <CustomTypography
              variant='h6'
              sx={{
                color: '#000',
                fontFamily: 'Montserrat',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: 'normal',
                textRransform: 'capitalize',
                display: 'flex',
                flex: '1',
              }}
            >
              Question
            </CustomTypography>
            <CustomTypography
              variant='h6'
              sx={{
                color: '#000',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: 'normal',
                textTransform: 'capitalize',
                display: 'flex',
                flex: '1',
              }}
            >
              {question_Title}
            </CustomTypography>
          </Box>
        </Box>
        <Divider
          sx={{
            width: '100%',
            height: '1px',
            background: '#E3E3E3',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            // gap: '100px',
            flex: '1',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '8px',
              flex: '1',
            }}
          >
            <CustomTypography
              variant='h6'
              sx={{
                color: '#000',
                fontFamily: 'Montserrat',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: 'normal',
                textRransform: 'capitalize',
                display: 'flex',
                flex: '1',
              }}
            >
              New Value
            </CustomTypography>
            <CustomTypography
              variant='h6'
              sx={{
                color: '#000',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: 'normal',
                textTransform: 'capitalize',
                display: 'flex',
                flex: '1',
              }}
            >
              {(() => {
                const answers =
                  saveData?.Answers[question?.Title]?.Answers || [];
                return renderFormattedAnswers(answers, question, true);
              })()}
            </CustomTypography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            flex: '1',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              paddingBottom: '6px',
              alignItems: 'flex-start',
              gap: '2px',
            }}
          >
            <CustomTypography
              variant='body1'
              sx={{
                color: '#343330',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontStyle: 'normal',
                fontEeight: '500',
                lineHeight: 'normal',
              }}
            >
              Reason
            </CustomTypography>
            <CustomTypography
              variant='body1'
              sx={{
                color: '#F35625',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
              }}
            >
              *
            </CustomTypography>
          </Box>
          <Select
            fullWidth
            onChange={handleSelectReason}
            value={selectedReason ? JSON.stringify(selectedReason) : ''}
          >
            {[...reasonOptions]
              ?.sort((a: any, b: any) => a?.text?.localeCompare(b?.text))
              ?.map((option: any) => (
                <MenuItem key={option?.id} value={JSON.stringify(option)}>
                  {option?.text}
                </MenuItem>
              ))}
          </Select>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
          }}
        >
          <CustomTypography
            variant='body1'
            sx={{
              display: 'flex',
              paddingBottom: '6px',
              alignItems: 'flex-start',
              gap: '2px',
              color: '#343330',
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: 'normal',
            }}
          >
            Comments
          </CustomTypography>
          <Textarea
            minRows={2}
            placeholder='Enter your comments here...'
            value={comment}
            sx={{
              color: '#343330',
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '24px',
            }}
            onChange={handleCommentChange}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
              marginTop: '10px',
            }}
          >
            <CustomTypography
              variant='body1'
              sx={{
                color: '#9C9D9E',
                textAlign: 'right',
                fontFamily: 'Montserrat',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: '16px',
              }}
            >
              {comment?.length}/{3800} Characters
            </CustomTypography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '42px',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            gap: '8px',
          }}
        >
          <Button
            variant='outlined'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              width: '100px',
              gap: '8px',
              borderRadius: '48px',
              border: '1px solid #E3E3E3',
              background: '#FFF',
              color: '#343330',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '28px',
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            sx={{
              display: 'flex',
              height: '42px',
              width: '200px',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: '8px',
              borderRadius: '48px',
              border: '1px solid #E3E3E3',
              background: '#1C6EC9',
              color: '#FFF',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '28px',
            }}
            onClick={() => {
              setSelectedReason(null);
              handleSendFollowUp(selectedReason, comment);
            }}
            disabled={!selectedReason || !comment}
          >
            Send Follow-Up
          </Button>
        </Box>
      </Box>
    </ReusableModal>
  );
};

export default SendFollowup;
